module.exports = {
    region: 'vn',
    registerUrl: 'http://90trade.com', //注册地址
    title: '90Trade - Đầu tư thể thao - Cơ hội kiếm tiền mới', //标题
    description: '90Trade là nền tảng đầu tư phản tỷ số thể thao online lớn nhất châu Á, uy tín, thu nhập ổn định, đơn giản, dễ hiểu. Miễn phí đăng ký, nền tảng ổn định, an toàn bảo mật cao, được nhiều người chơi tin tưởng và đánh giá cao.', //描述
    tgUrl: 'https://t.me/M_90Trade'
}